import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["password", "confirmation", "rules", "confirmationError",
                     "ruleLength", "ruleLower", "ruleUpper", "ruleDigit", "ruleSpecial"]
  static values = { mismatchMessage: String }

  connect() {
    this.element.addEventListener("submit", this.handleSubmit)
  }

  disconnect() {
    this.element.removeEventListener("submit", this.handleSubmit)
  }

  handleSubmit = (event) => {
    if (!this.checkPassword() || !this.checkConfirmation()) {
      event.preventDefault()
      event.stopPropagation()
    }
  }

  validatePassword() {
    this.checkPassword()
    if (this.confirmationTarget.value) this.checkConfirmation()
  }

  validateConfirmation() {
    this.checkConfirmation()
  }

  checkPassword() {
    const val = this.passwordTarget.value
    if (!val) {
      this.rulesTarget.style.display = "none"
      this.passwordTarget.style.borderColor = ""
      return false
    }
    this.rulesTarget.style.display = "block"

    const checks = {
      ruleLength:  val.length >= 8 && val.length <= 70,
      ruleLower:   /[a-z]/.test(val),
      ruleUpper:   /[A-Z]/.test(val),
      ruleDigit:   /[0-9]/.test(val),
      ruleSpecial: /[^a-zA-Z0-9]/.test(val)
    }

    let allValid = true
    for (const [target, pass] of Object.entries(checks)) {
      const el = this[target + "Target"]
      const label = el.dataset.label
      el.innerHTML = pass
        ? '<span style="margin-right:4px;color:#28a745;">&#10004;</span>' + label
        : '<span style="margin-right:4px;color:#dc3545;">&#10060;</span>' + label
      el.style.color = pass ? "#28a745" : "#dc3545"
      if (!pass) allValid = false
    }

    this.passwordTarget.style.borderColor = allValid ? "#28a745" : "#dc3545"
    return allValid
  }

  checkConfirmation() {
    const val = this.confirmationTarget.value
    if (!val) {
      this.confirmationTarget.style.borderColor = ""
      this.confirmationErrorTarget.style.display = "none"
      return false
    }
    const match = val === this.passwordTarget.value
    this.confirmationTarget.style.borderColor = match ? "#28a745" : "#dc3545"
    this.confirmationErrorTarget.style.display = match ? "none" : "block"
    return match
  }
}
